/*
 * Compare Rowers — inline "Which rower fits you?" quiz (native)
 * Page: /pages/compare-rowers (template: page.bundle-comparison)
 *
 * Promoted from Variant test EXP021D9AE8, Variant 1 (winner).
 * Replaces the "Need help choosing between models?" section's link-out button with a
 * 5-question quiz built from the page's own comparison specs. Recommends the Luxe or
 * the Lite and links to the same shop destination the page's "Shop the ..." buttons use.
 *
 * Analytics: pushes rower_quiz_* events to the GTM dataLayer (GTM-5BZKW4N).
 */
(function () {
  'use strict';
 
  var ROOT_ID = 'vq-quiz';
  var SOURCE = 'native'; // was Variant EXP021D9AE8 / variation 1
 
  function track(name, data) {
    try {
      var payload = { event: name, quiz_source: SOURCE };
      if (data) for (var k in data) payload[k] = data[k];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) { /* never break the page for analytics */ }
  }
 
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
 
  // ---------- Quiz content (all claims come from the page's comparison specs) ----------
  var QUESTIONS = [
    {
      id: 'fit',
      title: 'Will anyone who rows be taller than 6\'4" or weigh over 320 lbs?',
      options: [
        { id: 'yes', label: 'Yes', hard: 'luxe', reason: { luxe: 'Fits riders up to 6\'8" (40" inseam) and 500 lbs' } },
        { id: 'no', label: 'No' },
        { id: 'unsure', label: 'Not sure', luxe: 1 }
      ]
    },
    {
      id: 'space',
      title: 'How much floor length can you give it while rowing?',
      options: [
        { id: 'under8', label: 'Less than 8 feet', hard: 'lite', reason: { lite: 'Smaller footprint that fits your room' } },
        { id: 'over8', label: '8 feet or more' }
      ]
    },
    {
      id: 'budget',
      title: 'What\'s your budget range for a rower?',
      options: [
        // Low range skews Lite, middle is neutral (other answers decide), top range skews Luxe
        { id: 'low', label: '$1,299 - $1,699', lite: 2, reason: { lite: 'Lower price with the full Ergatta experience' } },
        { id: 'mid', label: '$1,700 - $1,999' },
        { id: 'high', label: '$2,000+', luxe: 2 }
      ]
    },
    {
      id: 'seat',
      title: 'Would a higher seat make getting on and off easier?',
      options: [
        { id: 'yes', label: 'Yes, a higher seat would help (20 in)', luxe: 3, reason: { luxe: 'Compatible with the High-Rise Kit for a 20" seat height' } },
        { id: 'no', label: 'No, standard height is fine (11-12 in)' }
      ]
    },
    {
      id: 'priority',
      title: 'What matters most to you?',
      options: [
        { id: 'screen', label: 'A bigger screen and premium sound', luxe: 2, reason: { luxe: '21.5" Full HD touchscreen with premium built-in speakers' } },
        { id: 'design', label: 'A statement piece in cherrywood', luxe: 2, reason: { luxe: 'Handcrafted from American cherrywood' } },
        { id: 'compact', label: 'Compact and budget-friendly', lite: 2, reason: { lite: ['Smaller footprint that fits your room', 'Lower price with the full Ergatta experience'] } }
      ]
    }
  ];
 
  var FALLBACK_REASONS = {
    luxe: ['Handcrafted from American cherrywood', '21.5" Full HD touchscreen with premium built-in speakers'],
    lite: ['Handcrafted from American oakwood', '17.3" Full HD touchscreen with built-in speakers', 'Smaller footprint that fits your room']
  };
 
  // ---------- Read live rower data (name, price, image, shop link) from the page ----------
  function readRower(index, fallback) {
    var col = document.querySelector('.section-comparison-overview .comparison-overview__column--' + index);
    var data = { name: fallback.name, href: fallback.href, priceHTML: '', srcset: '', src: '' };
    if (!col) return data;
    var title = col.querySelector('.text-column__title');
    if (title && title.textContent.trim()) data.name = title.textContent.trim();
    var btn = col.querySelector('.comparison-overview__button a[href]');
    if (btn) data.href = btn.getAttribute('href');
    var price = col.querySelector('.comparison-overview__price');
    if (price && price.querySelector('.theme-money')) data.priceHTML = price.innerHTML;
    var img = col.querySelector('.text-column__image img');
    if (img) {
      data.srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      data.src = img.getAttribute('src') || '';
      if (!data.src && data.srcset) data.src = data.srcset.split(',')[0].trim().split(' ')[0];
    }
    return data;
  }
 
  // ---------- Styles ----------
  var CSS = [
    '.vq-title{opacity:1 !important;transform:none !important;}',
    '.vq-title .vq-word{display:inline-block;opacity:0;transform:translateY(.55em);filter:blur(4px);transition:opacity .55s ease,transform .55s cubic-bezier(.2,.7,.2,1),filter .55s ease;}',
    '.vq-title.vq-title--in .vq-word{opacity:1;transform:none;filter:none;}',
    '@media (prefers-reduced-motion:reduce){.vq-title .vq-word{opacity:1;transform:none;filter:none;transition:none;}}',
    '#vq-quiz{max-width:560px;margin:24px auto 0;text-align:left;color:#fff;font-family:var(--font-body);}',
    '#vq-quiz *{box-sizing:border-box;}',
    '#vq-quiz .vq-intro{font-family:var(--font-body);font-size:1rem;line-height:1.5;letter-spacing:.03em;text-align:center;margin:0 0 28px;color:#fff;}',
    '#vq-quiz .vq-bar{height:4px;background:rgba(255,255,255,.15);margin:0 0 24px;overflow:hidden;}',
    '#vq-quiz .vq-bar span{display:block;height:100%;background:#ff8e0e;transition:width .45s ease;}',
    '#vq-quiz .vq-q{font-family:var(--font-header);text-transform:uppercase;letter-spacing:.1em;font-size:1.125rem;line-height:1.4;text-align:left;margin:0 0 20px;color:#fff;outline:none;}',
    '#vq-quiz .vq-options{display:flex;flex-direction:column;gap:10px;margin:0;padding:0;list-style:none;}',
    '#vq-quiz .vq-options li{margin:0;padding:0;list-style:none;}',
    '#vq-quiz .vq-opt{display:flex;align-items:center;gap:14px;width:100%;min-height:58px;margin:0;padding:14px 18px;background:transparent;color:#fff;border:1px solid rgba(255,255,255,.35);border-radius:0;font-family:var(--font-body);font-size:1.0625rem;line-height:1.35;letter-spacing:.03em;text-align:left;text-transform:none;cursor:pointer;transition:border-color .15s ease,background-color .15s ease;}',
    '#vq-quiz .vq-opt:hover{border-color:#ff8e0e;background:rgba(255,142,14,.06);color:#fff;}',
    '#vq-quiz .vq-opt:hover svg,#vq-quiz .vq-opt svg{fill:none;}',
    '#vq-quiz .vq-opt:focus-visible,#vq-quiz .vq-link:focus-visible,#vq-quiz .vq-cta:focus-visible,#vq-quiz .vq-back:focus-visible{outline:2px solid #ff8e0e;outline-offset:2px;}',
    '#vq-quiz .vq-opt[aria-pressed="true"]{border-color:#ff8e0e;background:rgba(255,142,14,.1);}',
    '#vq-quiz .vq-dot{flex:0 0 18px;width:18px;height:18px;border:1px solid rgba(255,255,255,.6);border-radius:50%;position:relative;}',
    '#vq-quiz .vq-opt[aria-pressed="true"] .vq-dot{border-color:#ff8e0e;}',
    '#vq-quiz .vq-opt[aria-pressed="true"] .vq-dot:after{content:"";position:absolute;inset:4px;border-radius:50%;background:#ff8e0e;}',
    '#vq-quiz .vq-back{display:inline-block;margin:18px 0 0;padding:6px 0;background:none;border:0;border-radius:0;color:#8392A2;font-family:var(--font-header);text-transform:uppercase;letter-spacing:.1em;font-size:.75rem;cursor:pointer;min-width:0;height:auto;}',
    '#vq-quiz .vq-back:hover{color:#fff;background:none;}',
    '#vq-quiz .vq-result{border:1px solid rgba(255,142,14,.4);background:rgba(255,142,14,.05);padding:24px 20px;}',
    '#vq-quiz .vq-eyebrow{font-family:var(--font-header);text-transform:uppercase;letter-spacing:.1em;font-size:.75rem;color:#ff8e0e;margin:0 0 6px;}',
    '#vq-quiz .vq-name{font-family:var(--font-header);text-transform:uppercase;letter-spacing:.1em;font-size:1.5rem;line-height:1.25;text-align:left;margin:0 0 6px;color:#fff;outline:none;}',
    '#vq-quiz .vq-price{margin:0 0 14px;}',
    '#vq-quiz .vq-price .price{text-align:left;}',
    '#vq-quiz .vq-img{display:block;width:100%;height:auto;aspect-ratio:4/3;object-fit:contain;margin:0 0 16px;}',
    '#vq-quiz .vq-why{font-family:var(--font-header);text-transform:uppercase;letter-spacing:.1em;font-size:.875rem;margin:0 0 10px;color:#fff;}',
    '#vq-quiz .vq-reasons{list-style:none;margin:0 0 14px;padding:0;}',
    '#vq-quiz .vq-reasons li{position:relative;margin:0 0 10px;padding:0 0 0 14px;border-left:2px solid #ff8e0e;font-size:1rem;line-height:1.45;letter-spacing:.03em;list-style:none;}',
    '#vq-quiz .vq-note{font-size:.9375rem;line-height:1.45;letter-spacing:.03em;color:#8392A2;margin:0 0 20px;}',
    '#vq-quiz .vq-cta{display:flex;align-items:center;justify-content:center;width:100%;min-height:58px;padding:14px 20px;background:#dd370e;color:#fff;border:0;border-radius:0;font-family:var(--font-header);text-transform:uppercase;letter-spacing:.1em;font-size:1rem;text-decoration:none;text-align:center;}',
    '#vq-quiz .vq-cta:hover{color:#fff;opacity:.92;}',
    '#vq-quiz .vq-actions{display:flex;justify-content:center;flex-wrap:wrap;gap:8px 28px;margin:18px 0 0;}',
    '#vq-quiz .vq-link{display:inline-block;padding:6px 0;background:none;border:0;border-bottom:1px solid rgba(255,255,255,.4);border-radius:0;color:#fff;font-family:var(--font-header);text-transform:uppercase;letter-spacing:.1em;font-size:.8125rem;text-decoration:none;cursor:pointer;min-width:0;height:auto;}',
    '#vq-quiz .vq-link:hover{color:#ff8e0e;background:none;border-bottom-color:#ff8e0e;}',
    '#vq-quiz .vq-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;}',
    '#vq-quiz .vq-step{animation:vqIn .25s ease;}',
    '@keyframes vqIn{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:none;}}',
    '@media (prefers-reduced-motion:reduce){#vq-quiz .vq-step{animation:none;}#vq-quiz .vq-bar span{transition:none;}}',
    '@media (min-width:768px){#vq-quiz{margin-top:32px;}#vq-quiz .vq-q{font-size:1.25rem;}#vq-quiz .vq-result{padding:32px;}#vq-quiz .vq-name{font-size:2rem;}}'
  ].join('\n');
 
  // ---------- Animated section title: words rise in one by one ----------
  function animateTitle(title) {
    if (!title || title.getAttribute('data-vq-anim')) return;
    title.setAttribute('data-vq-anim', '1');
 
    // Hand the title over from the theme's own fade so the two don't fight
    title.classList.remove('cc-fade-in-up', 'cc-animate-init');
    title.removeAttribute('data-cc-animate');
    title.style.transitionDelay = '';
 
    var words = title.textContent.trim().split(/\s+/);
    title.textContent = '';
    words.forEach(function (w, i) {
      var span = document.createElement('span');
      span.className = 'vq-word';
      span.style.transitionDelay = (i * 90) + 'ms';
      span.textContent = w;
      title.appendChild(span);
      if (i < words.length - 1) title.appendChild(document.createTextNode(' '));
    });
    title.classList.add('vq-title');
 
    var reveal = function () { title.classList.add('vq-title--in'); };
    if (!('IntersectionObserver' in window)) { reveal(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { reveal(); io.disconnect(); }
      });
    }, { threshold: 0.4 });
    io.observe(title);
  }
 
  function init() {
    if (document.getElementById(ROOT_ID)) return;
 
    // Anchor: the "Need help choosing between models?" section (links to the old quiz page)
    var quizLink = document.querySelector('a[href*="/pages/quiz-compare-rowers"]');
    var section = (quizLink && quizLink.closest('.shopify-section')) ||
      document.querySelector('.shopify-section[id$="__rich_text_GiwPyU"]');
    if (!section) return;
    var content = section.querySelector('.content') || section;
 
    // Move the quiz section directly below the "Which rower is right for you?" rowers section
    var machinesSection = document.querySelector('.shopify-section.section-comparison-overview');
    // (The template already orders it there; this is just a safety net.)
    if (machinesSection && machinesSection !== section && machinesSection.nextElementSibling !== section && machinesSection.parentNode) {
      machinesSection.parentNode.insertBefore(section, machinesSection.nextSibling);
    }
 
    var rowers = {
      luxe: readRower(0, { name: 'The Ergatta Luxe', href: '/collections/accessory-bundles' }),
      lite: readRower(1, { name: 'The Ergatta Lite', href: '/collections/accessory-bundles-lite' })
    };
 
    // Specs section to scroll back to
    var overviews = document.querySelectorAll('.shopify-section.section-comparison-overview');
    var specsSection = overviews.length > 1 ? overviews[1] : null;
 
    // Styles
    var style = document.createElement('style');
    style.id = 'vq-quiz-style';
    style.textContent = CSS;
    document.head.appendChild(style);
 
    // Hide the original intro copy + link-out button; the quiz carries its own intro
    var oldCopy = content.querySelector('.rte');
    var oldBtnRow = content.querySelector('.button-row');
    if (oldCopy) oldCopy.style.display = 'none';
    if (oldBtnRow) oldBtnRow.style.display = 'none';
 
    animateTitle(content.querySelector('h2'));
 
    var root = document.createElement('div');
    root.id = ROOT_ID;
    root.setAttribute('role', 'region');
    root.setAttribute('aria-label', 'Rower match quiz');
    content.appendChild(root);
 
    var live = document.createElement('div');
    live.className = 'vq-sr';
    live.setAttribute('aria-live', 'polite');
 
    var state = { step: 0, answers: {}, started: false, busy: false };
 
    function keepInView() {
      var rect = root.getBoundingClientRect();
      var offset = 100;
      if (rect.top < offset) window.scrollBy({ top: rect.top - offset, behavior: 'smooth' });
    }
 
    function focusEl(el) {
      if (!el) return;
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    }
 
    // Progress bar: rendered at the previous fill, then eased to the new one
    var lastPct = 0;
    function barHTML(pct) {
      var from = lastPct;
      lastPct = pct;
      return '<div class="vq-bar" role="progressbar" aria-label="Quiz progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
        '<span data-to="' + pct + '" style="width:' + from + '%"></span></div>';
    }
    function fillBar() {
      var fill = root.querySelector('.vq-bar span[data-to]');
      if (!fill) return;
      setTimeout(function () { fill.style.width = fill.getAttribute('data-to') + '%'; }, 30);
    }
 
    function renderQuestion() {
      var q = QUESTIONS[state.step];
      var total = QUESTIONS.length;
      var chosen = state.answers[q.id];
      // Intro copy stays on every question; it only goes away on the result
      var html = '<p class="vq-intro">Answer ' + total + ' quick questions and we\'ll match you with the rower that fits your space, style and budget.</p>' +
        barHTML(Math.round(((state.step + 1) / (total + 1)) * 100)) +
        '<div class="vq-step">' +
        '<h3 class="vq-q" id="vq-q-' + q.id + '" tabindex="-1">' + esc(q.title) + '</h3>' +
        '<ul class="vq-options" role="group" aria-labelledby="vq-q-' + q.id + '">';
      q.options.forEach(function (o) {
        html += '<li><button type="button" class="vq-opt" data-opt="' + o.id + '" aria-pressed="' + (chosen === o.id ? 'true' : 'false') + '">' +
          '<span class="vq-dot" aria-hidden="true"></span><span>' + esc(o.label) + '</span></button></li>';
      });
      html += '</ul>';
      if (state.step > 0) html += '<button type="button" class="vq-back">&larr; Back</button>';
      html += '</div>';
      root.innerHTML = html;
      root.appendChild(live);
      fillBar();
      live.textContent = 'Question ' + (state.step + 1) + ' of ' + total + ': ' + q.title;
    }
 
    function computeResult() {
      var score = { luxe: 0, lite: 0 };
      var hard = { luxe: false, lite: false };
      var picked = [];
      QUESTIONS.forEach(function (q) {
        var id = state.answers[q.id];
        var o = q.options.filter(function (x) { return x.id === id; })[0];
        if (!o) return;
        picked.push(o);
        if (o.luxe) score.luxe += o.luxe;
        if (o.lite) score.lite += o.lite;
        if (o.hard) hard[o.hard] = true;
      });
      var winner;
      if (hard.luxe) winner = 'luxe';           // rider size is a fit/safety limit — it wins
      else if (hard.lite) winner = 'lite';      // under 8 ft of floor only fits the Lite
      else winner = score.luxe >= score.lite ? 'luxe' : 'lite';
 
      // Bullets are never repeated within one result: every bullet (matched or backup)
      // goes through addReason, which skips anything already shown (ignoring case/spacing)
      var reasons = [];
      var seen = {};
      function addReason(t) {
        var key = String(t).toLowerCase().replace(/\s+/g, ' ').trim();
        if (!key || seen[key]) return;
        seen[key] = true;
        reasons.push(t);
      }
      picked.forEach(function (o) {
        var list = o.reason && o.reason[winner];
        if (list) [].concat(list).forEach(addReason);
      });
      FALLBACK_REASONS[winner].forEach(function (r) {
        if (reasons.length < 2) addReason(r);
      });
      return {
        winner: winner,
        reasons: reasons.slice(0, 3),
        conflict: hard.luxe && hard.lite,
        score: score
      };
    }
 
    function renderResult() {
      var res = computeResult();
      var r = rowers[res.winner];
      var other = rowers[res.winner === 'luxe' ? 'lite' : 'luxe'];
      var html = barHTML(100) + '<div class="vq-step">' +
        '<div class="vq-result">' +
        '<p class="vq-eyebrow">Your match</p>' +
        '<h3 class="vq-name" tabindex="-1">' + esc(r.name) + '</h3>';
      if (r.priceHTML) html += '<div class="vq-price"><div class="price comparison-overview__price">' + r.priceHTML + '</div></div>';
      if (r.src) {
        html += '<img class="vq-img" src="' + esc(r.src) + '"' +
          (r.srcset ? ' srcset="' + esc(r.srcset) + '" sizes="(min-width: 768px) 520px, 90vw"' : '') +
          ' alt="' + esc(r.name) + '" width="1080" height="810" loading="lazy">';
      }
      html += '<p class="vq-why">Why it fits you</p><ul class="vq-reasons">';
      res.reasons.forEach(function (t) { html += '<li>' + esc(t) + '</li>'; });
      html += '</ul>';
      if (res.conflict) {
        html += '<p class="vq-note">Heads up: the Luxe needs at least 8 ft of floor space and 7.5 ft of ceiling height to store upright, so it\'s worth measuring first.</p>';
      } else {
        html += '<p class="vq-note">Both rowers include the same game-based workout experience.</p>';
      }
      html += '<a class="vq-cta" href="' + esc(r.href) + '">Shop ' + esc(r.name.replace(/^The\s+/i, 'the ')) + '</a>' +
        '</div>' +
        '<div class="vq-actions">' +
        (specsSection ? '<a class="vq-link vq-compare" href="#' + esc(specsSection.id) + '">Compare full specs</a>' : '') +
        '<button type="button" class="vq-link vq-retake">Retake quiz</button>' +
        '</div></div>';
      root.innerHTML = html;
      root.appendChild(live);
      fillBar();
      live.textContent = 'Your match is ' + r.name + '.';
 
      track('rower_quiz_completed', {
        result: res.winner,
        luxe_score: res.score.luxe,
        lite_score: res.score.lite,
        answers: JSON.stringify(state.answers)
      });
      state.result = res.winner;
      state.otherName = other.name;
    }
 
    function goTo(step) {
      state.step = step;
      if (step >= QUESTIONS.length) {
        renderResult();
        focusEl(root.querySelector('.vq-name'));
      } else {
        renderQuestion();
        focusEl(root.querySelector('.vq-q'));
      }
      keepInView();
    }
 
    // Single delegated click handler for the whole quiz
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.vq-opt');
      if (opt) {
        if (state.busy) return;
        var q = QUESTIONS[state.step];
        var answerId = opt.getAttribute('data-opt');
        state.answers[q.id] = answerId;
        if (!state.started) {
          state.started = true;
          track('rower_quiz_started', {});
        }
        track('rower_quiz_answered', { question_id: q.id, answer_id: answerId, step: state.step + 1 });
        root.querySelectorAll('.vq-opt').forEach(function (b) {
          b.setAttribute('aria-pressed', b === opt ? 'true' : 'false');
        });
        state.busy = true;
        setTimeout(function () {
          state.busy = false;
          goTo(state.step + 1);
        }, 280);
        return;
      }
 
      if (e.target.closest('.vq-back')) {
        track('rower_quiz_back', { from_step: state.step + 1 });
        goTo(Math.max(0, state.step - 1));
        return;
      }
 
      if (e.target.closest('.vq-retake')) {
        track('rower_quiz_retaken', { previous_result: state.result || '' });
        state.answers = {};
        goTo(0);
        return;
      }
 
      var compare = e.target.closest('.vq-compare');
      if (compare && specsSection) {
        e.preventDefault();
        track('rower_quiz_compare_clicked', { result: state.result || '' });
        var top = specsSection.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
        return;
      }
 
      var cta = e.target.closest('.vq-cta');
      if (cta) {
        // dataLayer.push is synchronous, so the event is queued before the browser navigates
        track('rower_quiz_shop_clicked', { result: state.result || '' });
      }
    });
 
    renderQuestion();
 
    // Impression: fire once when the quiz first scrolls into view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            track('rower_quiz_viewed', {});
            io.disconnect();
          }
        });
      }, { threshold: 0.3 });
      io.observe(root);
    }
  }
 
  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { try { init(); } catch (e) {} });
    } else {
      init();
    }
  } catch (e) { /* fail silently */ }
})();